<template>
  <div ref="mailingModalRef" class="modal fade mailing-modal" id="mailingModal" tabindex="-1" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content p-5">
        <div class="modal-header border-0 d-flex flex-column align-items-center p-0">
          <img :src="mailingModal.logo.link" class="mb-4" :alt="mailingModal.logo.alt">
          <p class="h2 text-primary text-center">{{ mailingModal.title }}</p>
          <button type="button" class="btn-close position-absolute modal-search__btn-close" data-bs-dismiss="modal"
                  aria-label="Close" @click="handleClick"></button>
        </div>
        <div class="modal-body d-flex justify-content-center p-0">
          <div v-html="mailingModal.description"></div>
        </div>
        <div class="modal-footer p-0 border-0">
          <ButtonRed
              :href="mailingModal.button.link"
              :text="mailingModal.button.text"
              download
              class="w-100 m-0 mt-3"
              @click="handleClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonRed from "@/components/common/ButtonRed";

export default {
  components: {ButtonRed},
  props: {
    mailingModal: {
      logo: {
        alt: String,
        link: String,
      },
      title: String,
      description: String,
      button: {
        text: String,
        link: String
      }
    }
  },
  methods: {
    handleClick(){
      this.$emit('closeModal')
    },
  },
}
</script>
